import { AppointmentCreatePrescriptionOnlyCommand } from '@dreryk/egabinet-appointment-frontend-api';
import { ServiceLocationId, ServiceLocationType } from '@dreryk/egabinet-healthcare-provider-published-language-api';
import { PatientId } from '@dreryk/egabinet-patient-published-language-api';
import { PractitionerId } from '@dreryk/egabinet-personnel-published-language-api';
import { VisitAndAppointmentPrescriptionOnlyViewQuery } from '@dreryk/egabinet-visit-frontend-api';

import { refetchCqrsQuery, useCqrsCommand } from '@dreryk/command-query-react-common';
import { TranslatableText } from '@dreryk/react-common';
import { ModalConfirmButton } from '@dreryk/react-components';
import { Choice } from '@dreryk/watermelon';

import { prescriptionVisitsTranslationKeys } from '../../translations';
import { PrescriptionVisitFormBean, PrescriptionVisitFormController } from '../form/PrescriptionVisitForm.types';

type PrescriptionVisitSaveButtonProps = Pick<PrescriptionVisitFormController, 'handleSubmit'> & {
   readonly onSuccess: VoidFunction;
   readonly label?: TranslatableText;
};

export const PrescriptionVisitSaveButton = (props: PrescriptionVisitSaveButtonProps): JSX.Element => {
   const { executeAsync: createPrescriptionVisit } = useCqrsCommand<void, PrescriptionVisitFormBean>(
      (bean) => {
         const command = new AppointmentCreatePrescriptionOnlyCommand();
         command.patientId = PatientId.of(bean.patient!.id);
         command.practitionerId = PractitionerId.of(bean.practitioner!.practitionerId);
         command.locationId = ServiceLocationId.of(
            bean.healthcareProviderLocation!.locationIdentifier.type as ServiceLocationType,
            bean.healthcareProviderLocation!.locationIdentifier.locationId
         );
         command.date = bean.date;
         command.note = Choice.withUseDefaultIfNull(bean.note || null);
         if (bean.receptionService) {
            command.receptionServiceIds = [bean.receptionService.id];
         }
         return command;
      },
      {
         onSuccess: () => {
            refetchCqrsQuery(VisitAndAppointmentPrescriptionOnlyViewQuery);
            props.onSuccess();
         },
      }
   );

   return (
      <ModalConfirmButton
         label={props.label ?? prescriptionVisitsTranslationKeys.form.register}
         onClick={props.handleSubmit(createPrescriptionVisit)}
         testId={'registerPrescriptionVisit'}
      />
   );
};
